import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\CreateInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/CreateInvoiceController.php
* @route '/api/invoicing'
*/
const CreateInvoiceController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateInvoiceController.url(options),
    method: 'post',
})

CreateInvoiceController.definition = {
    methods: ["post"],
    url: '/api/invoicing',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Invoice\CreateInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/CreateInvoiceController.php
* @route '/api/invoicing'
*/
CreateInvoiceController.url = (options?: RouteQueryOptions) => {
    return CreateInvoiceController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\CreateInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/CreateInvoiceController.php
* @route '/api/invoicing'
*/
CreateInvoiceController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateInvoiceController.url(options),
    method: 'post',
})

export default CreateInvoiceController